exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal .btn.btn-arrow{min-width:140px}.modal .btn-outline-secondary+.btn-arrow{margin:auto;margin-right:0}.modal .modal-dialog{min-width:900px}.modal .modal-content{min-height:500px}.modal .col-form-label,.modal .col .label{font-size:smaller}", ""]);

// exports
